/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedGovIcon16Solid = forwardRef('BookClosedGovIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4a3 3 0 0 1 3-3h6.5A1.5 1.5 0 0 1 13 2.5v8a1.5 1.5 0 0 1-1.5 1.5H4.214a.75.75 0 0 0 .036 1.499h8a.75.75 0 0 1 0 1.5h-8a2.25 2.25 0 0 1-2.25-2.2V4Zm3 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v3.03c0 .69-.56 1.25-1.25 1.25h-.126a.25.25 0 0 1-.037.047l-.91.91a.25.25 0 0 1-.354 0l-.91-.91a.25.25 0 0 1-.037-.047H6.25C5.56 8.78 5 8.22 5 7.53V4.5Z" })));
});
